(function(angular){
	'use strict';
	
	var documentListObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			documents: '<',
			w9: '<?'
		},
		controller: [
			'mixpanelFactory',
			DocumentListFunction
		],
		controllerAs: 'documentList'
	};
	
	angular
		.module('agreementsModule')
		.component('documentList', documentListObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/agreements/document-list.html';
	}
	
	function DocumentListFunction(
		mixpanelFactory
	){
		var documentList = this;

		documentList.$onInit = function() {
			documentList.numDocumentsVisible = 6;
		};

		documentList.$onChanges = function() {
			if(angular.isDefined(documentList.w9)) {
				documentList.documents.push(documentList.w9);
			}
		};

		documentList.clickedDocument = function(clickedDocument) {
			mixpanelFactory.track('Document List - Document Clicked', {
				title: clickedDocument.title,
				revisionId: clickedDocument.documentRevisionId
			});
		};

		documentList.showAll = function() {
			documentList.showingAll = true;
			documentList.numDocumentsVisible = angular.isDefined(documentList.documents) ? documentList.documents.length : 0;
		};
	}
})(window.angular);